
<template>
  <a-card :bordered="false">
    <a-steps class="steps" :current="currentTab">
      <a-step v-for="item in steps" :key="item.title" :title="item.title">
      </a-step>
    </a-steps>
    <div class="content">
      <div v-if="currentTab == 0">
        <a-form style="max-width: 500px; margin: 80px auto 0;" :form="form">
          <mtc-form-item label="label.company"  :labelCol="{span: 5}" :wrapperCol="{span: 19}">
            <j-search-select-tag ref="companyInfo" type="list" v-model="form.company" @change="companyChange"  dict="sys_depart,depart_name,org_code,org_category='1' and del_flag = '0'" :placeholder="$t('label.pleaseSelectCompany')" />
          </mtc-form-item>
          <mtc-form-item label="label.periodCode" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
            <j-dict-select-tag type="list" v-model="form.period" :dictCode="accountPeriodDict" :placeholder="$t('label.pleaseSelectPeriod')" />
          </mtc-form-item>
          <a-form-item :wrapperCol="{span: 19, offset: 5}">
            <mtc-button type="primary" @click="nextStep" text="button.next"></mtc-button>
          </a-form-item>
        </a-form>
      </div>
      <div v-if="currentTab != 0">
        {{$t('label.company')}}:{{form.company}}-{{companyName}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$t('label.periodCode')}}:{{form.period}}
      </div>



      <div v-if="currentTab != 0">
        <div v-if="currentTab != this.steps.length-1">
          <a-form-item v-for="item in stepLabels" :key="item.key" :label="item.text" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
            <a-tooltip>
              <template slot='title'>
                {{item.title}}
              </template>
              <a-icon v-if="item.status == '30'" type="check-circle" style="color:green;" />
              <a-icon v-else-if="item.status == '20'" type="redo" style="color:blue;" spin />
              <a-icon v-else-if="item.status == '40'" type="close-circle" style="color:red;" />
              <a-icon v-else type="question-circle" style="color:orange;" />
            </a-tooltip>
          </a-form-item>
        </div>
        <div v-else>
          <mtc-form-item label="label.selectVoucher">
            <a-radio-group :options="certificateList" v-model="form.certificate"/>
          </mtc-form-item>
          <div>
            {{certificateResult}}
          </div>
        </div>

        <a-form style="max-width: 500px; margin: 40px auto 0;" v-if="currentTab != this.steps.length-1">
          <a-form-item :wrapperCol="{span: 19, offset: 5}">
            <mtc-button :disabled="retryLoading" @click="prevStep" text="button.previous"></mtc-button>
            <mtc-button style="margin-left: 8px" :loading="retryLoading" @click="retry" text="button.execute"></mtc-button>
            <mtc-button style="margin-left: 8px" type="primary" :disabled="retryLoading" @click="nextStep" text="button.next"></mtc-button>
          </a-form-item>
        </a-form>
        <a-form style="max-width: 500px; margin: 40px auto 0;" v-else>
          <a-form-item :wrapperCol="{span: 19, offset: 5}">
            <mtc-button :disabled="retryLoading" @click="prevStep" text="button.previous"></mtc-button>
            <mtc-button style="margin-left: 8px" :loading="retryLoading" @click="retry" text="button.execute"></mtc-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </a-card>
</template>

<script>
    import { ajaxGetDictItems,getCheckServiceGroup } from '@/api/api'
    import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
    import JDictSelectTag from '@/components/dict/JDictSelectTag'
    import { postJsonAction, getAction } from '@/api/manage'

    export default {
        name: "costaccountingForm",
        components: {
            JSearchSelectTag,
            JDictSelectTag,
        },
        data() {
            return {
                currentTab: 0,
                accountPeriodDict: null,
                form: {},
                steps: [],
                stepLabels: [],
                retryLoading: false,
                columns: [
                    {
                        title: '凭证编码',
                        dataIndex: 'accountCode',
                    },
                    {
                        title: '摘要',
                        dataIndex: 'docTitle',
                    },
                    // {
                    //   title: '方向',
                    //   dataIndex: 'key2',
                    // },
                    {
                        title: '科目代码',
                        dataIndex: 'ledgerAccount',
                    },
                    {
                        title: '科目名称',
                        dataIndex: 'accountName',
                    },
                    {
                        title: '金额',
                        dataIndex: 'amount',
                    },
                    {
                        title: '过账码',
                        dataIndex: 'postCode',
                    },
                    {
                        title: '成本中心',
                        dataIndex: 'costCenter',
                    },
                    {
                        title: '内部订单',
                        dataIndex: 'orderCode',
                    },
                    {
                        title: '物料',
                        dataIndex: 'mmCode',
                    },
                    // {
                    //   title: '客户',
                    //   dataIndex: 'customerCode',
                    // },
                    {
                        title: '凭证号',
                        dataIndex: 'docNo',
                    },
                ],
                dataSource: [],
                url: {
                    getSyncInterface: '/cost/sync/getSyncInterface',
                },
                companyName: '',
                serviceGroupCodeName:'',
                certificateList: [{"label": this.$t("generateVoucher"), "value": "10"}, {"label": this.$t("syncVoucher"), "value": "20"}, {"label": this.$t("reverseVoucher"), "value": "30"}],
                form: {"certificate": '10'},
                certificateResult: '',
            }
        },
        created() {
            // 接口：
            this.initStep();
        },
        methods: {
            initStep() {
                ajaxGetDictItems('cost_execution', null).then((res) => {
                    if (res.success) {
                        this.steps = res.result;
                    }
                })
            },
            companyChange(param) {
                this.$refs.companyInfo.options.map(item => {
                    if (item.value == param) {
                        this.companyName = item.title
                    }
                });
                this.accountPeriodDict = "efs_sys_account_period,period_code,period_code,status='B' AND valid_flag = 'Y' AND del_flag = 'N' AND company_code = '" + param + "' order by period_code desc"
            },


            nextStep() {
               if (this.form.company && this.form.period) {
                   this.currentTab += 1;
                   this.stepLabels = [];
               }

            },

            prevStep() {
                this.currentTab -= 1;
                this.stepLabels = [];
            },
            retry() {
                const that = this;
                this.retryLoading = true
                let url = '/costaccounting/efsFiCostAcc/getCostCalculation'
                let _request = [{
                    company: this.form.company,
                    period: this.form.period,
                    step: this.steps[this.currentTab]['value'],
                    certificate: this.form.certificate,
                }]
                postJsonAction(url, JSON.stringify(_request)).then(res => {
                    this.retryLoading = false;

                    if(res.success){
                        that.$message.success(res.result.message);
                    }else{
                        that.$message.warning(res.message);
                    }
                    this.resultCashback(res);
                    if(this.currentTab == 3){
                        let message=res.result.message.split("(");
                        if(this.form.certificate=="10"){
                            this.certificateResult="{{$t(Generate Voucher)}}("+message[1];
                        }else if(this.form.certificate=="20"){
                            this.certificateResult="Syn. Voucher("+message[1];
                        }else if(this.form.certificate=="30"){
                            this.certificateResult="Reverse Voucher("+message[1];
                        }

                    }
                })
            },
            resultCashback(res){//步骤
                if (this.currentTab == 1) {
                    if(res.code==200){
                        let twoExtract = [
                            {
                                title: this.$t("extractMaterialCost"),
                                text: this.$t("extractMaterialCost"),
                                status: 30
                            },
                            {
                                title: this.$t("extractOverhead"),
                                text: this.$t("extractOverhead"),
                                status: 30
                            },{
                                title: this.$t("extractStockVariance"),
                                text: this.$t("extractStockVariance"),
                                status: 30
                            }
                        ];
                        this.stepLabels = twoExtract;
                    }else{
                        let twoExtract = [
                            {
                                title: this.$t("extractMaterialCost"),
                                text: this.$t("extractMaterialCost"),
                                status: 40
                            },
                            {
                                title: this.$t("extractOverhead"),
                                text: this.$t("extractOverhead"),
                                status: 40
                            },{
                                title: this.$t("extractStockVariance"),
                                text: this.$t("extractStockVariance"),
                                status: 40
                            }
                        ];
                        this.stepLabels = twoExtract;
                    }
                }else if (this.currentTab == 2) {
                    if(res.code==200){
                        let threeExtract = [
                            {
                                title:this.$t('allocateMaterialCost'),
                                text: this.$t('AllocateMaterialCost'),
                                status: 30
                            },
                            {
                                title: this.$t('AllocateOverhead'),
                                text: this.$t('AllocateOverhead'),
                                status: 30
                            }
                            // ,{
                            //     title: '转场成本核算',
                            //     text: '转场成本核算',
                            //     status: 30
                            // }
                            ,{
                                title: this.$t('allocateCatchCost'),
                                text: this.$t('allocateCatchCost'),
                                status: 30
                            }
                        ];
                        this.stepLabels = threeExtract;
                    }else{
                        let threeExtract = [
                            {
                                title: this.$t('allocateMaterialCost'),
                                text: this.$t('allocateMaterialCost'),
                                status: 40
                            },
                            {
                                title: this.$t('allocateOverhead'),
                                text: this.$t('allocateOverhead'),
                                status: 40
                            }
                            // ,{
                            //     title: '转场成本核算',
                            //     text: '转场成本核算',
                            //     status: 40
                            // }
                            ,{
                                title: this.$t('allocateCatchCost'),
                                text: this.$t('allocateCatchCost'),
                                status: 40
                            }
                        ];
                        this.stepLabels = threeExtract;
                    }

                }
            }

        }
    }
</script>

<style lang="less" scoped>
  .steps {
    margin: 16px auto;
  }
</style>